import i18next from 'i18next';

export const rejectErrorCodeHelper = (error) => {
  const errorCode = error?.response?.data?.Errors[0]?.Code;

  if (errorCode === 'UserAlreadyExists') {
    const errorMsg = error?.response?.data.Errors[0].Message;
    return errorMsg.split('-')[2];
  }
  const errorMessage = errorCode ? i18next.t(`apiErrors.${errorCode}`) : '';

  return errorMessage;
};
